var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "user" } },
    [
      _c("div", { staticClass: "bg" }),
      _c("div", { staticClass: "user-info-con" }, [
        _c("div", { staticClass: "user-info" }, [
          _c("div", { staticClass: "user-top" }, [
            _c("div", { staticClass: "avatar-con" }, [
              _c(
                "div",
                { staticClass: "avatar" },
                [
                  _c("c-avatar", {
                    attrs: {
                      src: _vm.user.avatar,
                      width: "100%",
                      vip: _vm.user.vipLevel,
                      is_streamer: _vm.user.isStreamer,
                      curr_metal_url: _vm.user.currMetalUrl,
                    },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "name-con" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v("UID: " + _vm._s(_vm.user.uid)),
                ]),
              ]),
              _c("div", { staticClass: "name-con" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.user.nickname)),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "btn-recharge",
                on: {
                  click: function ($event) {
                    return _vm.setPayModal(true)
                  },
                },
              },
              [
                _c("Icon", { attrs: { type: "md-card" } }),
                _c(
                  "span",
                  {
                    staticClass: "text",
                    staticStyle: { "margin-left": "6px" },
                  },
                  [_vm._v("充值")]
                ),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "line" }),
        _c("div", { staticClass: "tradeUrL" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "input-con", on: { click: _vm.onTradeUrlClick } },
            [
              _c("c-svg", { staticClass: "icon", attrs: { src: "link.svg" } }),
              _vm.user.tradeUrl
                ? _c("p", [_vm._v("https://steam***********************")])
                : _c("p", [_vm._v("绑定交易链接后，可进行物品取回操作")]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "scroll" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _vm.aclList.indexOf("/user/inventory") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "inventory" },
                    },
                  },
                  [_vm._v(" 我的背包 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/caseHistory") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "caseHistory" },
                    },
                  },
                  [_vm._v(" 开箱记录 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/boxBattleHistory") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "boxBattleHistory" },
                    },
                  },
                  [_vm._v(" 盒战记录 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/userInfo") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "userinfo" },
                    },
                  },
                  [_vm._v(" 个人资料 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/ranks/rank/his") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "rankHis" },
                    },
                  },
                  [
                    _vm._v(" 排行活动 "),
                    _vm.hasRank
                      ? _c("span", { staticClass: "point" })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/getbackList") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "getbackList" },
                    },
                  },
                  [_vm._v(" 取回记录 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/getsubbackList") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "getSubBackList" },
                    },
                  },
                  [_vm._v(" 赠送物品记录 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/wallet") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: { "active-class": "active", to: { name: "wallet" } },
                  },
                  [_vm._v(" 账单记录 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/coin1") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: { "active-class": "active", to: { name: "coin1" } },
                  },
                  [_vm._v(" 金豆明细 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/rechargeHistory") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "rechargeHistory" },
                    },
                  },
                  [_vm._v(" 充值记录 ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/usdtWithdraw") == -1 &&
            _vm.user.isAllowUsdtWithdraw
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "usdtWithdraw" },
                    },
                  },
                  [_vm._v(" USDT ")]
                )
              : _vm._e(),
            _vm.aclList.indexOf("/user/commission") == -1
              ? _c(
                  "router-link",
                  {
                    attrs: {
                      "active-class": "active",
                      to: { name: "commission" },
                    },
                  },
                  [_vm._v(" 佣金记录 ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "user_content" }, [_c("router-view")], 1),
      _c("steam-trade-url-modal", {
        attrs: { "initial-url": _vm.modifyTradeModal.url },
        model: {
          value: _vm.modifyTradeModal.flag,
          callback: function ($$v) {
            _vm.$set(_vm.modifyTradeModal, "flag", $$v)
          },
          expression: "modifyTradeModal.flag",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "desc" }, [_vm._v("STEAM 交易链接")]),
      _c(
        "a",
        {
          staticClass: "link",
          attrs: {
            href: "http://steamcommunity.com/id/me/tradeoffers/privacy#trade_offer_access_url",
            target: "_blank",
          },
        },
        [_vm._v(" 获取交易链接 ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }